export default __webpack_public_path__ + "static/media/app-store dark.6bcac199.svg";